import { useContext, useEffect } from 'react';
import ModalContext from '~/context/home/ModalContext';
import { NativeModalId } from '~/context/home/ModalContext/constants';
import sendMessageToOpenNativeModal from './sendMessageToOpenNativeModal';

export default function useModalMessageDispatcher() {
  const { isSoftPullModalOpen, setSoftPullModalOpen } =
    useContext(ModalContext);

  useEffect(() => {
    if (isSoftPullModalOpen) {
      sendMessageToOpenNativeModal(NativeModalId.SoftPull, () =>
        setSoftPullModalOpen(false)
      );
    }
  }, [isSoftPullModalOpen, setSoftPullModalOpen]);
}
